// UI For Leaderboard Avatars
var QGIV = QGIV || {};
var Leaderboard = function(options){
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

Leaderboard.prototype = {
    // shorthand for using prototype
    constructor : Leaderboard,

    // default options
    defaults : {},

    pagination : {},

    init : function(){
        var _this = this;

        var $container = $('.leaderboard.users'),
            $els = $container.find('.leaderboard-item');

        // add animations to top users
        $els.each(function(index) {
            var el = this,
                func = setTimeout(function() {
                $(el).addClass('active');
                }, 150 * index);

            if ( index + 1 === $els.length ) {
            setTimeout(function() {
                $container.addClass('complete');
            }, 1000);
            }
        });

        // init tablesorter and pagination plugins
        $('.data-table-stack').paginate();
        $('#sortableTable').sorter();

        _this.pagination = $('.paginate').paginate();
        $('.sorter').sorter();
    }
}

$(document).ready(function(){
    var leaderboard = new Leaderboard();
    QGIV.Leaderboard = leaderboard;
    QGIV.Leaderboard.init();
});